// extracted by mini-css-extract-plugin
export default {"scrollbar":"scrollbar--17ffa2bb","thin":"thin--ecbcb16b","medium":"medium--01b013f6","thick":"thick--2939e4fb","fixedSpace":"fixedSpace--7acf556a"};